import { DateTime } from 'luxon'

import { capitalizeString } from '@domain-group/javascript-utils'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'

import type { PublicationModel } from '@models/types'
import type { Deadlines } from '@models/publication'

const days = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
}

type DeadlinesListItemProps = {
  deadlineKey: keyof Deadlines,
  publication: PublicationModel,
}

const DeadlinesListItem = (props: DeadlinesListItemProps) => {
  const { deadlineKey, publication } = props

  const { currentUser } = useCurrentUser()
  const { time_zone: current_user_time_zone } = currentUser

  const { deadlines, options, time_zone: publication_time_zone } = publication
  const deadlineData = deadlines![deadlineKey] || {}

  const { day, time, weeks_before } = deadlineData

  if (!time) return null

  const originalDateTime = DateTime.fromFormat(time, 'H:mm', { zone: publication_time_zone })
  // @ts-expect-error TS2339
  const convertedDateTime = originalDateTime.setZone(options && options.enable_time_zones
    ? current_user_time_zone
    : publication_time_zone)

  return (
    <ListItem
      boxProps={{
        as: 'a',
        alignItems: 'center',
        borderBottom: '1px dashed',
        padding: 'medium',
      }}
      disableHover
    >
      <Box flexDirection="column">
        <Text color="bodyFontLightColor" fontSize="small" lineHeight="1.3">
          {capitalizeString(deadlineKey)}
        </Text>
      </Box>

      <Box justifyContent="flex-end" marginLeft="auto" textAlign="right">
        <Text color="bodyFontLightColor" fontSize="small">
          {/*
           // @ts-expect-error TS2367 */}
          {weeks_before === '0' ? 'Same Week' : 'Previous Week'} {days[day]} at {convertedDateTime.toFormat('h:mm a')}
        </Text>
      </Box>
    </ListItem>
  )
}

export default DeadlinesListItem
